export enum AppRoutes {
  HOME = "/",
  JOB_SEARCH = "/jobs",
  JOB = "job",
  COMPLETE_APPLICATION = "/complete-application",
  SIGNUP = "/signup",
  LOGIN = "/login",
  LINKEDIN_CALLBACK = "/auth/linkedin/callback",
  FORGET_PASSWORD = "/forget-password",
  DASHBOARD = "/dashboard",
  ADMIN_DASHBOARD = "/admin-dashboard",
  RSS = "/feeds",
  CONTACT_US = "/contact-us",
  TERMS_AND_PRIVACY = "/terms-and-privacy",
  IMPRINT = "/imprint",
  GDPR = "/gdpr",
  ALERT_UNSUBSCRIBE = "/alerts/unsubscribe",
  JOB_ALERT = "/job-alerts",
}
